import * as React from 'react';
import { memo } from 'react';

import { format } from 'helper/dateTime';
import i18n from 'helper/i18n';
import { template } from 'helper/string';

import InfoSummary from 'components/atoms/InfoSummary';
import ProgressRadial from 'components/atoms/ProgressRadial';
import Bevel from 'components/helper/Bevel';

export type ProgramStatsPropsType = {
	calories: number;
	totalTodosDone: number;
	totalTodos: number;
	longestRun: number;
	weightLost: number;
	weightLostSince: number;
};

export const ProgramStats = ({
	calories = 0,
	totalTodos,
	totalTodosDone,
	longestRun,
	weightLost,
	weightLostSince,
}: ProgramStatsPropsType) => (
	<div className="m-program-stats">
		<div className="container">
			<div className="row">
				<div className="col-xs-12">
					<h2 className="m-program-stats__title">{i18n('react.impulsCoach.molecules.ProgramStats.title')}</h2>
					<div className="m-tiles">
						<div className="m-tiles__row">
							<div className="m-tiles__cell">
								<div className="m-tiles__box">
									<InfoSummary
										title={`${Math.round(calories)}`}
										text={i18n('react.impulsCoach.molecules.ProgramStats.calories.unit')}
									/>
								</div>
								<span className="m-tiles__box-label">
									{i18n('react.impulsCoach.molecules.ProgramStats.calories.label')}
								</span>
							</div>
							<div className="m-tiles__cell">
								<div className="m-tiles__box">
									<ProgressRadial
										reach={totalTodosDone}
										total={totalTodos}
										text={i18n('react.impulsCoach.molecules.ProgramStats.todos.text')}
										percent={(totalTodosDone / totalTodos) * 100 || 0}
									/>
								</div>
								<span className="m-tiles__box-label">
									{i18n('react.impulsCoach.molecules.ProgramStats.todos.label')}
								</span>
							</div>
						</div>
						<hr className="m-tiles__line" />
						<div className="m-tiles__row">
							<div className="m-tiles__cell">
								<div className="m-tiles__box">
									<InfoSummary
										title={`${longestRun}`}
										text={i18n(
											'react.impulsCoach.molecules.ProgramStats.days.unit',
											{},
											parseInt(`${longestRun}`, 10)
										)}
										image="flame"
									/>
								</div>
								<span className="m-tiles__box-label">
									{i18n('react.impulsCoach.molecules.ProgramStats.days.label')}
								</span>
							</div>
							<div className="m-tiles__cell">
								<div className="m-tiles__box">
									<InfoSummary
										title={`${Math.abs(weightLost)}`}
										text={i18n('react.impulsCoach.molecules.ProgramStats.weight.unit')}
										image={weightLost < 0 ? 'arrow-up' : 'arrow-down'}
									/>
								</div>
								<span className="m-tiles__box-text">
									{template(i18n('react.impulsCoach.molecules.ProgramStats.weight.label'), {
										date: format(weightLostSince),
									})}
								</span>
								<span className="m-tiles__box-label m-tiles__box-label--yellow">
									{weightLost < 0
										? i18n('react.impulsCoach.molecules.ProgramStats.weight.gained')
										: i18n('react.impulsCoach.molecules.ProgramStats.weight.lost')}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Bevel modifier="bottom-right" color="0099A6" />
	</div>
);

ProgramStats.displayName = 'ProgramStats';

export default memo(ProgramStats);
